// extracted by mini-css-extract-plugin
export default {"text":"_8s61yRv6"};